@for (optionGroup of optionGroups; let marketIndex = $index; track trackOptionGroup(marketIndex, optionGroup)) {
    <div [ngClass]="{ 'specials-market-group': checkIfSpecialMarket(optionGroup) }">
        @if (checkIfSpecialMarket(optionGroup)) {
            <div class="header" (click)="toggleHeader(marketIndex)">{{ optionGroup.name }}</div>
        }
        @for (option of optionGroup.options; track trackOption($index, option)) {
            <div
                class="participant-wrapper dervied-market-details special-market-container"
                [ngClass]="{ 'greyhounds-option': isGreyhounds }"
                [ngStyle]="
                    isFirstLoad
                        ? { display: 'flex' }
                        : this.valuesForToggle.includes(marketIndex) && checkIfSpecialMarket(optionGroup)
                          ? { display: 'none' }
                          : { display: 'flex' }
                ">
                @if (trapImages$ | async; as trapImages) {
                    @for (trapIndex of getAvailableTrapImages(option); track trapIndex) {
                        <div>
                            <div class="dog-trap">
                                <img fill alt="trap" [ngSrc]="trapImages[trapIndex]" />
                            </div>
                        </div>
                    }
                }
                @if (!checkIfWinningDistance(optionGroup) && !checkIfSpecialMarket(optionGroup)) {
                    <div class="special-market" [ngClass]="{ 'greyhounds-option': isGreyhounds }">
                        {{ option.name }}
                    </div>
                }
                @if (checkIfWinningDistance(optionGroup)) {
                    <div class="special-market">
                        {{
                            siteCore.horseRacing.common.WinningHowFarOption
                                | msInterpolate: { participantName: optionGroup.player1, optionName: option.name.toLowerCase() }
                        }}
                    </div>
                }
                <div class="special-market-pick" [ngClass]="{ 'specials-pick': checkIfSpecialMarket(optionGroup) }">
                    <ms-hr-option-pick
                        class="odds-info ms-selectable-pick odds-derived-info"
                        [option]="option"
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [trackingOptions]="trackingOptions"
                        [trackingSource]="trackingSource">
                        @if (checkIfSpecialMarket(optionGroup)) {
                            <div class="special-market" [ngClass]="{ 'greyhounds-option': isGreyhounds, 'locked-option': !option?.online }">
                                {{ option.name }}
                            </div>
                        }
                        @if (option?.online) {
                            <strong class="option-value">{{ option?.nativePrice | msNativePriceFormatter }}</strong>
                        } @else {
                            <div class="lock"><i class="theme-locked-i"></i></div>
                        }
                    </ms-hr-option-pick>
                    @if (!checkIfSpecialMarket(optionGroup) && checkIfOptionActive(option)) {
                        <div class="previous-odds">
                            @for (price of option?.priceHistory; track price) {
                                <span>{{ price | msExternalPriceFormatter }}</span>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}
